export default __webpack_public_path__ + "static/media/memorycard.ed894992.png";